// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "InspectIssueGroup" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { InspectShortlistEntryGenShape } from "./inspect-shortlist-entry.gen";
import { InspectConsideredCandidateGenShape } from "./inspect-considered-candidate.gen";

export const InspectIssueGroupGenShape = z.strictObject({
  issueIndex: z.number(),
  summary: z.string().optional(),
  isPrimary: z.boolean(),
  shortlist: z.array(InspectShortlistEntryGenShape),
  considered: z.array(InspectConsideredCandidateGenShape),
});
